import { connect } from 'react-redux';
import { selectCurrentBrand } from 'selectors';
import { Brands } from 'app/layout/components/header';

const mapStateToProps = (state) => ({
  brand: selectCurrentBrand(state),
});

export default connect(mapStateToProps)(Brands);
